<template>
  <div class="user_info_body">
    <div v-show="step === 1" class="deco">
      <h3 v-if="registerSelect === 2">개인 사업자</h3>
      <h3 v-else>법인 사업자</h3>
      <register-contact-business @update="(val) => (business.contact = val)"></register-contact-business>

      <register-business-info @update="(val) => (business.businessInfo = val)"></register-business-info>

      <register-account
        @update="(val) => (business.account = val)"
        :businessLicenseNumber="business.businessInfo.request.businessLicenseNumber"
        :businessType="registerSelect"
        description="업체명의 혹은 대표자명의 계좌번호만 신청이 가능합니다."
      ></register-account>

      <!-- 4. 개인사업자(주민등록번호 이미 수집) -> 법인사업자 : 주민등록번호 입력창 미노출되어야함 -->
      <template v-if="userInfo.businessType === 2 || userInfo.businessType === 3">
        <div></div>
      </template>
      <template v-else>
        <register-applicant-info @update="(val) => (individual.user = val)"></register-applicant-info>
      </template>
      <required-documents :businessType="registerSelect"></required-documents>

      <register-agree-business @update="(val) => (business.agree = val)"></register-agree-business>

      <div class="bt bt50">
        <v-button @handleClick="handlePrev" class="btn02" :text="btnTextPrev" />
        <v-button @handleClick="handleStep1" :disabled="btnDisabledStep1" class="btn01" :text="btnText" />
      </div>
    </div>

    <div v-show="step === 2" class="deco deco_no_padding_side" :class="{ rp_register: step === 2 }">
      <div class="point_withdraw">
        <h3>잔여 포인트 출금 정보</h3>
        <p>
          사업자로 사용자를 변경 하기 전에 쌓인 포인트는 개인 계좌로 출금이 될 예정입니다.<br />입금 받을 개인 계좌 등의
          정보를 입력해주세요.<br />
          포인트는 사업자 처리 승인이 완료 되는 시점에 자동으로 <em>현금 캐시백 신청</em>이 될 예정입니다.
        </p>
      </div>
      <register-user @update="(val) => (individual.user = val)"></register-user>

      <register-contact @update="(val) => (individual.contact = val)"></register-contact>

      <register-account
        @update="(val) => (individual.account = val)"
        :businessType="1"
        description="본인명의 계좌번호만 신청이 가능합니다.​"
      ></register-account>

      <register-agree @update="(val) => (individual.agree = val)"></register-agree>

      <div class="bt bt50" style="padding: 30px 15px 0 15px">
        <v-button @handleClick="step = 1" class="btn02" text="이전" />
        <v-button @handleClick="handleStep2" :disabled="btnDisabledStep2" class="btn01" text="등록 신청" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RegisterContactBusiness from '@/components/modules/userInfo/RegisterContactBusiness';
import RegisterBusinessInfo from '@/components/modules/userInfo/RegisterBusinessInfo';
import RegisterAccount from '@/components/modules/userInfo/RegisterAccount';
import RequiredDocuments from '@/components/modules/userInfo/RequiredDocuments';
import RegisterAgreeBusiness from '@/components/modules/userInfo/RegisterAgreeBusiness';
import RegisterUser from '@/components/modules/userInfo/RegisterUser';
import RegisterContact from '@/components/modules/userInfo/RegisterContact';
import RegisterAgree from '@/components/modules/userInfo/RegisterAgree';
import VButton from '@/components/atoms/VButton';
import { openerPostMessageClose } from '@/utils';
import RegisterApplicantInfo from '@/components/modules/userInfo/RegisterApplicantInfo/RegisterApplicantInfo.vue';

export default {
  components: {
    RegisterApplicantInfo,
    RegisterContactBusiness,
    RegisterBusinessInfo,
    RegisterAccount,
    RequiredDocuments,
    RegisterAgreeBusiness,
    RegisterUser,
    RegisterContact,
    RegisterAgree,
    VButton,
  },
  data() {
    return {
      step: 1,
      business: {
        contact: {},
        businessInfo: {
          request: {
            businessLicenseNumber: '',
          },
        },
        account: {},
        agree: {},
      },
      individual: {
        user: {},
        contact: {},
        account: {},
        agree: {},
        default: {
          businessType: 1,
          businessName: '',
          businessOwnerName: '',
          businessLicenseNumber: '',
          businessEmail: '',
        },
      },
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo', 'registerSelect']),
    btnText() {
      if (this.userInfo.businessType === 0) {
        if (this.userInfo.isRemainPoint) {
          return '다음';
        } else {
          return '등록 신청';
        }
      } else {
        return '변경 신청';
      }
    },
    btnTextPrev() {
      if (this.$route.name === 'UserInfoChange') {
        return '취소';
      } else {
        return '이전';
      }
    },
    btnDisabledStep1() {
      return (
        !this.individual.user.isState ||
        !this.business.contact.isState ||
        !this.business.businessInfo.isState ||
        !this.business.account.isState ||
        !this.business.agree.isState
      );
    },
    requestStep1() {
      return {
        ...this.business.contact.request,
        ...this.business.businessInfo.request,
        ...this.business.account.request,
        ...this.business.agree.request,
        ...this.individual.user.request,
        ...this.individual.account.request,
        ...{ businessType: this.registerSelect },
      };
    },
    btnDisabledStep2() {
      return (
        !this.individual.user.isState ||
        !this.individual.contact.isState ||
        !this.individual.account.isState ||
        !this.individual.agree.isState
      );
    },
    requestStep2() {
      return {
        // ...this.individual.user.request,
        ...this.individual.contact.request,
        ...this.individual.account.request,
        ...this.individual.agree.request,
        ...this.individual.default,
      };
    },
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    ...mapActions('userInfo', ['setRegisterSelect', 'setUserInfo', 'getUserInfo']),
    handlePrev() {
      this.setRegisterSelect(0);
      this.$router.back();
    },
    async handleStep1() {
      if (this.userInfo.isRemainPoint && this.userInfo.businessType === 0 && this.step === 1) {
        this.step = 2;
        this.$nextTick(() => {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        });
      } else {
        const apiSetReturn = await this.setUserInfo(this.requestStep1);
        if (apiSetReturn === 0) {
          const apiGetReturn = await this.getUserInfo();
          if (apiGetReturn === 0) {
            this.openModal({
              type: 'alert',
              header: '신청이 완료되었습니다.',
              message:
                '사업자 등록증 사본 / 통장 사본 / 인감 증명서 / 계좌 확인서를 rewardpoint_biz@nexon.co.kr 로 보내주시면 ​서류를 검토 후 승인처리를 해드립니다. ​ <br/>처리결과는 내정보>사업자 처리 내역에서 확인 하실 수 있습니다.',
              callback: () => {
                openerPostMessageClose();
                this.$router.replace({ name: 'UserInfoHistory' });
              },
            });
          }
        }
      }
    },
    async handleStep2() {
      const apiSetReturn = await this.setUserInfo(this.requestStep2);
      if (apiSetReturn === 0) {
        this.handleStep1();
      }
    },
  },
  unmounted() {
    this.setRegisterSelect(0);
  },
};
</script>

<style lang="scss" scoped>
.user_info_body {
  .deco {
    &.rp_register {
      padding: 0 0 30px 0;
    }
  }
}
</style>
